import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import GetVarBillingUsageDetailsTotalCountQuery from
  '@/graphql/contracts/getVarBillingUsageDetailsTotalCount.query.gql';
import { GetVarBillingUsageDetailsTotalCount, GetVarBillingUsageDetailsTotalCountVariables } from
  '@/graphql/contracts/_generated_/getVarBillingUsageDetailsTotalCount.query';
import { UsageDetailsPayload } from '../../types';

export default function useGetVarBillingUsageDetailsTotalCount() {
  const [_getVarBillingUsageDetailsTotalCount, { loading, error, data }] =
    useLazyQuery<GetVarBillingUsageDetailsTotalCount, GetVarBillingUsageDetailsTotalCountVariables>(
      GetVarBillingUsageDetailsTotalCountQuery,
      {
        client: apolloClientContracts,
        fetchPolicy: 'network-only',
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
      });

  const getVarBillingUsageDetailsTotalCount = (filter?: UsageDetailsPayload['filter']) => {
    _getVarBillingUsageDetailsTotalCount({
      variables: {
        filter,
      },
    });
  };

  return {
    getVarBillingUsageDetailsTotalCount,
    totalCount: data?.varBillingUsageDetailsTotals?.totalUsageRecordsCount ?? 0,
    isLoadingUsageDetailsTotalCount: loading,
    errorUsageDetailsTotalCount: error,
  } as const;
}
